// @flow

import LogTraffic from 'app/common/lib/LogTraffic';
import type { ClientContext } from 'app/common/lib/context';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import { type RequestContext } from 'app/common/lib/RequestContext';
import logStats, { getSampleRate } from 'app/common/lib/logStats';

function supportsNavigationTiming() {
  return !!(window && window.performance && window.performance.timing);
}

export default {
  supported() {
    if (!supportsNavigationTiming() || !window.requestAnimationFrame) {
      return false;
    }

    if (window.didLogQuickPerf) {
      return false;
    }
    return true;
  },

  enabled(rc: RequestContext): boolean {
    if (!this.supported()) {
      return false;
    }

    const exp = new SingleTreatmentExp(rc, 'www_unauth_measure_tti');
    return exp.enabled();
  },

  logFromClient(from: string, context: ClientContext) {
    if (!this.supported()) {
      return;
    }
    const { navigation, timing } = window.performance;
    const now = window.performance.now() + timing.navigationStart;

    const tags = {
      from,
      userAgentPlatform: LogTraffic.getAppTypeString(),
      moduleName: LogTraffic.getModuleName(),
      type: navigation.type,
      redirectCount: navigation.redirectCount,
      navigationStart: timing.navigationStart,
      fetchStart: timing.fetchStart,
      requestStart: timing.requestStart,
      responseStart: timing.responseStart,
      responseEnd: timing.responseEnd,
    };

    logStats.timing('webapp.performance_logs.www', now, getSampleRate(), tags);
    window.didLogQuickPerf = true;
  },
};
